import { Avatar, TableCell, TableRow, Typography } from "@material-ui/core";
import { ethers } from "ethers";
import { useState } from "react";
import InterestRateFactoryPool from "src/assets/abis/poolMonitoring/InterestRateFactoryPool.json";
import { useConfigContext } from "src/context/config/configContext";
import { StepStatus, useAddAssetContext } from "src/context/monitoring/addAssetContext";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import { useProviderContext } from "src/ether-utils/context/providerContext";
import { encodePackageData, getContractEditPool } from "src/hooks/useContractEditPool";
import useLowerAddressParam from "src/hooks/useLowerAddressParam";
import useNotify from "src/hooks/useNotify";
import { toFixed } from "src/services/utils";
import BaseAddPoolTable from "src/view/PoolMonitoring/Overview/AssetConfigOption/components/BaseAddPoolTable.js";
import BaseStep from "src/view/PoolMonitoring/Overview/AssetConfigOption/components/BaseStep";

export default function ThirdStep({ targetProviderId, ...props }) {
  const { pool } = useLowerAddressParam();
  const { currentProvider, wallet } = useProviderContext();
  const { addresses } = useConfigContext();
  const { assets, stepStatus, setter } = useAddAssetContext();
  const [isLoading, setLoading] = useState(false);
  const { errorNotify } = useNotify();
  const { data } = usePoolMonitoringContext();

  const onConfirmClick = async () => {
    setLoading(true);
    const contractEditPool = getContractEditPool(wallet.signer);
    try {
      setter.setStepStatus((draft) => {
        draft["activeStatus"] = StepStatus.LOADING;
      });
      const interestRateContract = new ethers.Contract(
        addresses.interestRateStrategyFactoryAddress,
        InterestRateFactoryPool,
        wallet.signer
      );
      const listInterestRateAddress = await interestRateContract.getListInterestRateAddress(
        targetProviderId,
        assets.map((item, _) => item["address"])
      );
      const reserveData = assets.map((item, index) => {
        return [
          addresses.T_TOKEN_LOGIC_ADDRESS,
          addresses.DEBT_TOKEN_LOGIC_ADDRESS,
          item["decimal"],
          listInterestRateAddress[index],
          item["address"],
          addresses.TREASURY_ADDRESS,
          addresses.INCENTIVES_ADDRESS,
          item["symbol"],
          `t${item["symbol"]}`,
          `t${item["symbol"]}`,
          `debt${item["symbol"]}`,
          `debt${item["symbol"]}`,
          "0x12",
          (item["loanToValue"] * 10000).toString(),
          (item["lt"] * 10000).toString(),
          ((item["liquidationBonus"] + 1) * 10000).toString(),
          (item["reserveFactor"] * 10000).toString(),
        ];
      });
      const reserveDataEncode = await encodePackageData(currentProvider, "batchInitReserve", [reserveData]);
      const _promise = await contractEditPool.submitTransaction(data[pool].overview.providerId, reserveDataEncode);
      await _promise.wait();
      setter.setStepStatus((draft) => {
        draft["activeStep"] = 2;
        draft["activeStatus"] = StepStatus.FINISH;
        draft["selectedStep"] = 2;
      });
      setLoading(false);
    } catch (err) {
      errorNotify(err.message);
      setter.setStepStatus((draft) => {
        draft["activeStatus"] = StepStatus.ERROR;
      });
      setLoading(false);
    }
  };

  const disabledBut =
    !(
      stepStatus.activeStep == 2 &&
      (stepStatus.activeStatus === StepStatus.INIT || stepStatus.activeStatus === StepStatus.ERROR)
    ) || isLoading;

  return (
    <BaseStep {...props} butProps={{ disabled: disabledBut, onClick: onConfirmClick }} isLoading={isLoading}>
      <BaseAddPoolTable
        tableHeaderConfig={[
          { text: "Asset" },
          { text: "Loan To Value" },
          { text: "Liquidation Threshold" },
          { text: "Reserve Factor" },
          { text: "Liquidation Bonus" },
        ]}
        isEmpty={assets.length == 0}
      >
        {assets.map((asset, index) => (
          <TableRow key={index}>
            <TableCell style={{ display: "flex", alignItems: "center", position: "sticky", left: 0 }}>
              <Avatar style={{ marginRight: 10, width: "25px", height: "25px" }} src={asset.image}></Avatar>
              <Typography style={{ fontWeight: "bold" }}>{asset.symbol}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.loanToValue * 100, 2)}%`}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.lt * 100, 2)}%`}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.reserveFactor * 100, 2)}%`}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.liquidationBonus * 100, 2)}%`}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </BaseAddPoolTable>
    </BaseStep>
  );
}
